export default "__VITE_ASSET__BjiXYQ81__"